// 获取url中的参数
function getParameter(name, url = window.location.search) {
    const regexp = new RegExp(`[?&]${name}=([^&#]*)`, 'ig');
    const result = regexp.exec(url);
    return result === null ? '' : decodeURIComponent(result[1]);
};

export { getParameter }